import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { FunctionComponent } from 'react';
import dayjs from 'dayjs';
import { timeFrameOptions } from 'src/features/reports/utils/timeFrameToDateUtils';
const TimeFrameDropdown: FunctionComponent<{
  value: string | 'custom';
  onChange: (val: string | [string, string]) => void;
  timeFrames?: typeof timeFrameOptions;
  testId?: string;
  error?: string;
}> = ({ value, onChange, timeFrames = timeFrameOptions, testId, error }) => (
  <FormControl size="small" fullWidth error={Boolean(error)}>
    <InputLabel htmlFor="timeframe-select">Time Frame</InputLabel>
    <Select
      id="timeframe-select"
      data-sm={testId}
      label="Time Frame"
      size="small"
      error={Boolean(error)}
      onChange={(event) => {
        if (event.target.value === 'custom') {
          const today = dayjs();
          onChange([today.format('YYYY-MM-DD'), today.format('YYYY-MM-DD')]);
          return;
        }
        onChange(event.target.value as string);
      }}
      value={Array.isArray(value) ? 'custom' : value}
    >
      {timeFrames.map((tf) => (
        <MenuItem key={tf.value} value={tf.value}>
          {tf.label}
        </MenuItem>
      ))}
      <MenuItem value="custom">Custom</MenuItem>
    </Select>
    {error && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);

export default TimeFrameDropdown;
